import { useTranslation } from "react-i18next";
import Accordion from "@/components/base/Accordion";

export default function Faq() {
  const { t } = useTranslation();

  const items = [1, 2, 3, 4, 5].map((n) => ({
    q: t(`faq.q${n}`),
    a: t(`faq.a${n}`),
  }));

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-3xl px-4 py-16 md:px-6 md:py-20">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">
            {t("faq.title")}
          </h2>
        </div>
        <div className="mt-10">
          <Accordion items={items} />
        </div>
      </div>
    </section>
  );
}